import { ElementType, Suspense, lazy } from 'react';

const Loadable = (Component: ElementType) => (props: object) => {
  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
};

export const OrderPage = Loadable(lazy(() => import('../../pages/order/OrderPage')));
export const BasketPage = Loadable(lazy(() => import('../../pages/basket/BasketPage')));
export const CatalogPage = Loadable(lazy(() => import('../../pages/catalog/CatalogPage')));
export const ProductPage = Loadable(lazy(() => import('../../pages/product/ProductPage')));
export const ProfilePage = Loadable(lazy(() => import('../../pages/profile/ProfilePage')));
export const SettingsPage = Loadable(lazy(() => import('../../pages/settings/SettingsPage')));
export const OrdersHistoryPage = Loadable(lazy(() => import('../../pages/order/OrdersHistoryPage')));
export const DocumentsPage = Loadable(lazy(() => import('../../pages/documents/DocumentsPage/DocumentsPage')));
export const AboutRestaurantPage = Loadable(lazy(() => import('../../pages/aboutRestaurant/AboutRestaurantPage')));
export const DocumentViewPage = Loadable(lazy(() => import('../../pages/documents/DocumentViewPage/DocumentViewPage')));
export const SuccessPage = Loadable(lazy(() => import('../../pages/success/SuccessPage')));
export const LandingPage = Loadable(lazy(() => import('../../pages/landing/LandingPage')));
export const DeveloperPage = Loadable(lazy(() => import('../../pages/developer/DeveloperPage')));
export const EmptyDeliveryTypesPage = Loadable(lazy(() => import('../../pages/error/EmptyDeliveryTypesPage')));
export const OAuthCallbackPage = Loadable(lazy(() => import('../../pages/oauth/OAuthCallbackPage')));
export const MagicLinkVerifyPage = Loadable(lazy(() => import('../../pages/magicLink/MagicLinkVerifyPage')));

export const ProductModal = Loadable(lazy(() => import('../../pages/modalPages/ProductModal/ProductModal')));
